/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect} from 'react'
import NavigationBar from '../components/NavBar'
import axios from 'axios'
import 'react-dropdown/style.css';
import { useSelector, useDispatch } from 'react-redux';
import GetSchedule from '../backendHandler/schedulingRoute'
import { 
    selectDrivers,
    addDrivers
} from '../features/drivers/driversSlice'
import {
    addRota,
    selectRotaData
} from '../features/rota/rotaSlice'
import {
    addImages, 
    selectImages
} from '../features/imagesSliceFile/imagesSlice'
import {
    addSchedule, 
    selectSchedule
} from '../features/schedule/scheduleSlice'
import {
    addVehicle, 
    selectVehicles
} from '../features/vehicles/vehiclesSlice'
import {
    addDocDriver,
    selectDocDriver
} from '../features/docDrivers/docDriversSlice'
import {
    addComplianceCheckData,
    selectComplianceCheck
} from '../features/compliancecheck/complianceCheckSlice'
import {
    addVanData,
    selectVanData
} from '../features/vanData/vanDataSlice'
import {
    addPayrollData,
    selectPayrollData
} from '../features/payroll/payrollSlice'

var displayObj = {
    'DBS2': 'Bristol',
    'DSN1': 'Swindon',
    'DEX2': 'Exeter',
    'DXP1': 'Plymouth',
    'DCF1': 'Truro'
}

const determineOffboarded = (offboradedContent, selectedFunctionDate) => {
    switch (offboradedContent) {
        case 'OffboardedForever':
            return false
        case 'Active':
            return true
        case 'verified':
            return true
        case null:
            return true        
        default:
            return false
    }
}
var driversObj = {}

var vehicleObj = {}

var myInterval
const Home = (props) => {

    async function putData(url = '', data={}) {
        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        const response = await fetch(url, {
            method: 'PUT', 
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${originalText}`
            },
            body: JSON.stringify(data)
        });
        return response ? response.json() : console.log('no reponse')
    };

    // functions for fetching data
    async function getData(url = '') {
        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        const response = await fetch(url, {
            method: 'GET', 
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${originalText}`
            },
        });
        return response ? response.json() : console.log('no reponse')
    };
    // redux stuff
    const reduxDrivers = useSelector(selectDrivers)
    const rotaData = useSelector(selectRotaData)
    const imageData = useSelector(selectImages)
    const scheduleData = useSelector(selectSchedule)
    const reduxVehicles = useSelector(selectVehicles)
    const docDrivers = useSelector(selectDocDriver)
    const complianceChcek = useSelector(selectComplianceCheck)
    const payroll = useSelector(selectPayrollData)

    // using the new backend route
    const [ requestGate, setRequestGate ] = useState(false)
    const [ handleSchedule, setHandleSchedule ] = useState(null)
    const [ dateSelection, setDateSelection ] = useState(new Date())
    
    // local state
    const [ loadingMessage, setLoadingMessage ] = useState('Loading Content')

    // get the week method
    // eslint-disable-next-line no-extend-native
    Date.prototype.getWeek = function () {
        var firstDate = new Date(this.getFullYear(), 0, 1)
        if (this.getFullYear() === 2021) {
            return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7) - 1
        } else {
            return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7)
        }
    }

    var CryptoJS = require("crypto-js");
    const [ selectedDate, setSelectedDate ] = useState(new Date())
    const [ currentDate, setCurrentDate ] = useState(new Date())
    const [ selectedCity, setSelectedCity ] = useState('DBS2')
    const [ schedule, setSchedule ] = useState(null)
    const [ loadingGate, setLoadingGate ] = useState(0)
    const [ theDateRandom, setTheDateRandom ] = useState(new Date())
    const [ verifiedDocumentsDivs, setVerifiedDocumentsDivs ] = useState(null)
    const [ expirationList, setExpirationList ] = useState(null)
    const [ quoteOfDay, setQuoteOfDay ] = useState(null)
    const [ quoteOfDayArray, setQuoteOfDayArray ] = useState([])
    const [ data, setData ] = useState(null)
    const [ todaysDrivers, setTodaysDrivers ] = useState(0)

    useEffect( () => {
        if (props.station) {
            if (props.station.length > 0) {
                setSelectedCity(props.station[0])
                // setSelectedCity()
            }
        }
    }, [props.station])

    const dispatch = useDispatch();
    useEffect( () => {
        var CryptoJS = require("crypto-js");
        async function postData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'POST', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
            });
            return response ? response.json() : console.log('no reponse')
        };

        const checkForOffboard = (driver) => {
            // check if driver needs offboarding
            if (driver.offBoard) {
                // check if the date is past the current date
                let offBoardDate = new Date(driver.offBoard)

                if (offBoardDate < new Date()) {
                    putData(`https://backendpajamas.herokuapp.com/drivers/${driver.driver_id}/`, {
                        status: 'OffboardedForever',
                        offBoard: null
                    }).then( response => {
                        postData(`https://backendpajamas.herokuapp.com/driverimages/`, {
                            "driver_id": driver.driver_id
                        }).then( responseImages => {
                            responseImages.data.forEach( image => {
                                if (image.verified !== 'offboarded') {
                                    putData(`https://backendpajamas.herokuapp.com/images/${image.image_id}/`, {
                                        verified: 'offboarded'
                                    })
                                }
                            })
                        })
                    })
                }
            }
        }

        // handle the drivers
        getData('https://backendpajamas.herokuapp.com/drivers/').then( response => {
            // check for drivers to offboard
            response.results.forEach( ele => {
                checkForOffboard(ele)
            })

            // setLoadingMessage('Drivers Arrived')
            dispatch(addDrivers(response.results))

            // handle the images
            getData('https://backendpajamas.herokuapp.com/images/').then( response => {
                // setLoadingMessage('Images Arrived')
                dispatch(addImages(response.results))

                // handle the vehicles
                getData('https://backendpajamas.herokuapp.com/vehicles/').then( response => {
                    // setLoadingMessage('Vehicles Arrived')
                    dispatch(addVehicle(response.results))
                    // handle the compliance check
                    // handle the van data
                    // getData('https://backendpajamas.herokuapp.com/vandata/').then( (response) => {
                    //     dispatch(addVanData(response.data))

                        // handle the schedule
                        let theDateWeek = new Date().getWeek()
                        postData('https://backendpajamas.herokuapp.com/weeksschedule/', {
                            week: theDateWeek
                        }).then( response => {
                            dispatch(addSchedule(response.data))
                            setHandleSchedule(
                                <>
                                    <GetSchedule 
                                        allGate={true}
                                        dateSelection={dateSelection}
                                    />
                                </>
                            )
                            // axios.get('https://quotes.rest/qod/inspire').then( response => {
                            //     setQuoteOfDay(response.data.contents.quotes[0])
                            // })
                        })
                    })
                })
            })
        // })
    }, [])

    // view the redux state
    useEffect( () => {
        if (scheduleData) {
            if (reduxDrivers.length > 0 && rotaData && imageData.length > 0 && reduxVehicles.length > 0) {
                reduxDrivers.forEach( driver => {
                    if (determineOffboarded(driver.status)) {
                        driversObj[`${driver.driver_id}`] = {
                            name: driver.name,
                            id: driver.driver_id,
                            location: driver.location,
                            status: driver.status
                        }
                    }
                })
                reduxVehicles.forEach( vehicle => {
                    if (!vehicle.offboarded) {
                        vehicleObj[`${vehicle.vehicle_id}`] = vehicle.registration
                    }
                })
                let myDate = new Date()
                while (myDate.getDay() > 0) {
                    myDate.setDate(myDate.getDate() - 1)
                }
                setSelectedDate(myDate)
                setSchedule(scheduleData)
                setData(imageData)
            }
        }
    }, [reduxDrivers, rotaData, imageData, scheduleData])

    // grab the data
    useEffect(() => {
        setLoadingGate(0)
        let myDate = new Date()
        while (myDate.getDay() > 0) {
            myDate.setDate(myDate.getDate() - 1)
        }
        setSelectedDate(myDate)
        async function getData(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'GET', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                }
            });

            return response ? response.json() : console.log('no reponse')

        };

        async function deleteData(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'DELETE', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                }
            });

        };

    }, [])

    // dropdown menu options
    const options = [
        'DBS2',
        'DSN1',
        'DEX2',
        'DXP1'
    ]

    // dropdown menu selection function
    const onSelect = (e) => {
        setSelectedCity(e.value)
    }

    // map todays booked drivers
    var chart
    useEffect( () => {
        if (schedule) {
            var randomDate 
            randomDate = theDateRandom.toDateString()
            let localNum = 0
            schedule.forEach( (ele, id) => {
                if (ele.date === randomDate.toString() && ele.location === selectedCity) {
                    localNum++
                }
            })
            setTodaysDrivers(
                <h3>Drivers Today at {selectedCity}: {localNum}</h3>
            )
        }

    }, [schedule, selectedCity, theDateRandom])
    
    // set city
    const handleSelectCity = (e, city) => {
        setSelectedCity(city)
    }

    // handling the clock
    useEffect( () => {
        clearInterval(myInterval)
        const timeFunction = () => {
            let setTime = () => {
                setCurrentDate(new Date())
            }
            myInterval = setInterval( setTime, 1000)
        }
        timeFunction()
    }, [])

    var dayArray = ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat']
    var monthArray = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul","Aug", "Sep", "Oct", "Nov", "Dec"]

    // eslint-disable-next-line no-extend-native
    Date.prototype.getWeek = function () {
        var firstDate = new Date(this.getFullYear(), 0, 1)
        if (this.getFullYear() === 2021) {
            return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7) - 1
        } else {
            return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7)
        }
    }

    // map the verified documents
    useEffect( () => {
        const returnNameVehicle = (identification) => {
            let indexNumber = identification.match(/\d+/)
            return vehicleObj[`${indexNumber}`] ? vehicleObj[`${indexNumber}`] : 'not found'
        }
        const returnNameDriver = (identification) => {
            let indexNumber = identification.match(/\d+/)
            return driversObj[`${indexNumber}`] ? driversObj[`${indexNumber}`].name : 'not found'
        }
        const returnObjectDriver = (identification) => {
            let indexNumber = identification.match(/\d+/)
            return driversObj[`${indexNumber}`] ? driversObj[`${indexNumber}`] : 'not found'
        }
        const returnNameDriverImages = (identification) => {
            let indexNumber = identification.match(/\d+/)
            return driversObj[`${indexNumber}`] ? driversObj[`${indexNumber}`].id : 'not found'
        }
        async function postData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'POST', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
            });
            return response ? response.json() : console.log('no reponse')
        };
        let localArray = []
        let expirationDatesArray = []
        let expirationDatesArrayDivs = []
        let rejected = 0
        let approved = 0
        let pending = 0
        let expired = 0
        let offboarded = 0
        let currentLocalDate = new Date()
        let thirtyDaysNotice = currentLocalDate.setDate(currentLocalDate.getDate() + 14)
        let currentLocalDateTwo = new Date()
        let fiveDaysLate = currentLocalDateTwo.setDate(currentLocalDateTwo.getDate() - 1)
        let rightArray = []
        let expiredArray = []
        let dvlaExpired = []
        let pendingArray = []
        if (data) {
            data.forEach( image => {
                if (!image.storageBool) {
                    if (image.verified !== 'offboarded') {
                        // docs for verification part
                        if (image.verified === 'False') {
                            rejected++
                        } else if (image.verified === 'True'){
                            approved++
                        } else if (image.verified === 'offboarded') {
                            offboarded++
                        } else {
                            if (image.driver_id) {
                                if (returnObjectDriver(image.driver_id)) {
                                    if (returnObjectDriver(image.driver_id).status === 'verified') {
                                        putData(`https://backendpajamas.herokuapp.com/drivers/${returnObjectDriver(image.driver_id).id}/`, {
                                            status: 'Active'
                                        }).then( response => {
                                            getData('https://backendpajamas.herokuapp.com/drivers/').then( response => {
                                                // setLoadingMessage('Drivers Arrived')
                                                dispatch(addDrivers(response.results))
                                            })
                                        })
                                    }
                                }
                            }

                            if (image.vehicle_id !== null) {
                                if (returnNameVehicle(image.vehicle_id) !== 'not found') {
                                    pendingArray.push(
                                        <>
                                            <div>
                                                <h3>Vehicle: {returnNameVehicle(image.vehicle_id)}</h3>
                                                <h3>{image.name}</h3>
                                            </div>
                                            <hr />
                                        </>
                                    )
                                }
                            } else {
                                if (returnNameDriver(image.driver_id) !== 'not found') {
                                    pendingArray.push(
                                        <>
                                            <div>
                                                <h3>Name: {returnNameDriver(image.driver_id)}</h3>
                                                <h3>{image.name}</h3>
                                            </div>
                                            <hr />
                                        </>
                                    )
                                }
                            }
                            pending++
                        }
                        if (image.name ==='DVLA Check' && new Date(image.expiryDate) < new Date()) {
                            dvlaExpired.push(image)
                        }
                        if (new Date(image.expiryDate) < new Date(thirtyDaysNotice) && new Date(image.expiryDate) >= fiveDaysLate) {
                            expirationDatesArray.push(image)
                        }
                        if (new Date(image.expiryDate) < new Date() && image.name !== 'DVLA Check' && image.name !== 'D&A test') {
                            if (image.vehicle_id !== null) {
                                if (returnNameVehicle(image.vehicle_id) !== 'not found') {
                                    expiredArray.push(image)
                                    expired++
                                }
                            } else {
                                if (returnNameDriver(image.driver_id) !== 'not found') {
                                    expiredArray.push(image)
                                    expired++
                                }
                            }
                        }
                    }
                }
            })
            setLoadingGate(2)
        }
        localArray.push(
            <div className='docs_for_verification_home'>
                <div className='pending_div'><h3 className='remove_padding'>{pending} Pending</h3>
                    <div className='pendingInnerArrayContainer'>
                        {pendingArray}
                    </div>
                </div>
                <div className='rejected_div'><h3 className='remove_padding'>{rejected} Rejected</h3></div>
                <div className='approved_div'><h3 className='remove_padding'>{approved} Approved</h3></div>
                <div className='expired_div'><h3 className='remove_padding'>{expired} Expired</h3></div>
            </div>
        )
        setVerifiedDocumentsDivs(localArray)
        // localArray.push(
            //     <div className='docs_for_verification_home'>
            //         <div className='rejected_div'><h3 className='remove_padding'>{rejected} Rejected</h3></div>
            //         <div className='approved_div'><h3 className='remove_padding'>{approved} Approved</h3></div>
            //         <div className='pending_div'><h3 className='remove_padding'>{pending} Pending</h3></div>
            //     </div>
            // )
            // setVerifiedDocumentsDivs(localArray)
            // console.log(expirationDatesArray, driversObj, vehicleObj)
        // console.log(expirationDatesArray) 
        expirationDatesArray.sort((a, b) => (new Date(a.expiryDate) > new Date(b.expiryDate) ? 1 : -1))   
        let dbs2Array = []
        let dsn1Array = []
        let dex2Array = []
        let DCF1Array = []
        let dxp1Array = []
        let vehicleArray = []
        expirationDatesArray.forEach( (image, imageID) => {
            if (image.status !== 'offboarded') {
                if ( image.name !== 'D&A test' && image.name !== 'DVLA Check') {
                    if (image.vehicle_id !== null) {
                        if (returnNameVehicle(image.vehicle_id) !== 'not found') {
                            vehicleArray.push(
                                <div className="whiteBox">
                                    <h3>{image.vehicle_id !== null ? `Van Registration: ${returnNameVehicle(image.vehicle_id)}` : `Driver: ${returnNameDriver(image.driver_id)}`}</h3>
                                    <h3>Document Name: {image.name}</h3>
                                    <h3>Expiration Date: {new Date(image.expiryDate).toDateString()}</h3>
                                    <br />
                                </div>
                            )
                        }
                    } else {
                        if (returnNameDriver(image.driver_id) !== 'not found') {
                            switch (returnObjectDriver(image.driver_id).location) {
                                case "DBS2":
                                    dbs2Array.push(
                                        <div className="whiteBox">
                                            <h3>{image.vehicle_id !== null ? `Van Registration: ${returnNameVehicle(image.vehicle_id)}` : `Driver: ${returnNameDriver(image.driver_id)}`}</h3>
                                            <h3>Document Name: {image.name}</h3>
                                            <h3>Expiration Date: {new Date(image.expiryDate).toDateString()}</h3>
                                            <br />
                                        </div>
                                    )
                                break;
                                case "DSN1":
                                    dsn1Array.push(
                                        <div className="whiteBox">
                                            <h3>{image.vehicle_id !== null ? `Van Registration: ${returnNameVehicle(image.vehicle_id)}` : `Driver: ${returnNameDriver(image.driver_id)}`}</h3>
                                            <h3>Document Name: {image.name}</h3>
                                            <h3>Expiration Date: {new Date(image.expiryDate).toDateString()}</h3>
                                            <br />
                                        </div>
                                    )
                                    break;
                                case "DEX2":
                                    dex2Array.push(
                                        <div className="whiteBox">
                                            <h3>{image.vehicle_id !== null ? `Van Registration: ${returnNameVehicle(image.vehicle_id)}` : `Driver: ${returnNameDriver(image.driver_id)}`}</h3>
                                            <h3>Document Name: {image.name}</h3>
                                            <h3>Expiration Date: {new Date(image.expiryDate).toDateString()}</h3>
                                            <br />
                                        </div>
                                    )
                                    break;
                                case "DCF1":
                                    DCF1Array.push(
                                        <div className="whiteBox">
                                            <h3>{image.vehicle_id !== null ? `Van Registration: ${returnNameVehicle(image.vehicle_id)}` : `Driver: ${returnNameDriver(image.driver_id)}`}</h3>
                                            <h3>Document Name: {image.name}</h3>
                                            <h3>Expiration Date: {new Date(image.expiryDate).toDateString()}</h3>
                                            <br />
                                        </div>
                                    )    
                                    break;
                                case "DXP1":
                                    dxp1Array.push(
                                        <div className="whiteBox">
                                            <h3>{image.vehicle_id !== null ? `Van Registration: ${returnNameVehicle(image.vehicle_id)}` : `Driver: ${returnNameDriver(image.driver_id)}`}</h3>
                                            <h3>Document Name: {image.name}</h3>
                                            <h3>Expiration Date: {new Date(image.expiryDate).toDateString()}</h3>
                                            <br />
                                        </div>
                                    )
                                    break;
                                default:
                                    break;
                            }
                        }
                    }
                }
            }
        })
        if (dbs2Array.length > 0) {
            expirationDatesArrayDivs.push(
                <>
                    <h3>DBS2</h3>
                    {dbs2Array}
                </>
            )
        }
        if (dex2Array.length > 0) {
            expirationDatesArrayDivs.push(
                <>
                    <h3>DEX2</h3>
                    {dex2Array}
                </>
            )
        }
        if (dsn1Array.length > 0) {
            expirationDatesArrayDivs.push(
                <>
                    <h3>DSN1</h3>
                    {dsn1Array}
                </>
            )
        }
        if (DCF1Array.length > 0) {
            expirationDatesArrayDivs.push(
                <>
                    <h3>DCF1</h3>    
                    {DCF1Array}
                </>
            )
        }
        if (dxp1Array.length > 0) {
            expirationDatesArrayDivs.push(
                <>
                    <h3>DXP1</h3>
                    {dxp1Array}
                </>
            )
        }
        if (vehicleArray.length > 0) {
            expirationDatesArrayDivs.push(
                <>
                    <h3>Vehicles</h3>
                    {vehicleArray}
                </>    
            )
        }
        setExpirationList(expirationDatesArrayDivs)
        async function awaitDataFunction() {
            const result = Promise.all(expirationDatesArray.map( (image, image_id ) => {
                if (image.name === 'DVLA Check') {
                    if (returnNameDriver(image.driver_id) !== 'not found') {
                        return postData(`https://backendpajamas.herokuapp.com/driverimages/`, {
                            "driver_id": returnNameDriverImages(image.driver_id)
                        }).then ( response => {
                            let dvlaArray = []
                            response.data.forEach( image => {
                                if (image.name === 'DVLA Check') {
                                    dvlaArray.push(image)
                                }
                            })
                            dvlaArray.sort((a, b) => (new Date(a.expiryDate) > new Date(b.expiryDate)) ? 1 : -1)
                            let dvlaDoc = null
                            dvlaDoc = dvlaArray[dvlaArray.length - 1]
                            if (dvlaDoc.image_id === image.image_id) {
                                if (dvlaDoc !== null) {
                                    if (returnNameDriver(image.driver_id) !== 'not found') {
                                        switch (returnObjectDriver(image.driver_id).location) {
                                            case "DBS2":
                                                return ({
                                                    "DBS2": <div className="whiteBox">
                                                                <h3>{image.vehicle_id !== null ? `Van Registration: ${returnNameVehicle(image.vehicle_id)}` : `Driver: ${returnNameDriver(image.driver_id)}`}</h3>
                                                                <h3>Document Name: {image.name}</h3>
                                                                <h3>Expiration Date: {new Date(image.expiryDate).toDateString()}</h3>
                                                                <br />
                                                            </div>
                                                        })
                                            case "DSN1":
                                                return({
                                                    "DSN1": <div className="whiteBox">
                                                                <h3>{image.vehicle_id !== null ? `Van Registration: ${returnNameVehicle(image.vehicle_id)}` : `Driver: ${returnNameDriver(image.driver_id)}`}</h3>
                                                                <h3>Document Name: {image.name}</h3>
                                                                <h3>Expiration Date: {new Date(image.expiryDate).toDateString()}</h3>
                                                                <br />
                                                            </div>
                                                        })
                                            case "DEX2":
                                                return ({
                                                    "DEX2": <div className="whiteBox">
                                                                <h3>{image.vehicle_id !== null ? `Van Registration: ${returnNameVehicle(image.vehicle_id)}` : `Driver: ${returnNameDriver(image.driver_id)}`}</h3>
                                                                <h3>Document Name: {image.name}</h3>
                                                                <h3>Expiration Date: {new Date(image.expiryDate).toDateString()}</h3>
                                                                <br />
                                                            </div>
                                                        })
                                            case "DCF1":
                                                return({
                                                    "DCF1": <div className="whiteBox">
                                                                <h3>{image.vehicle_id !== null ? `Van Registration: ${returnNameVehicle(image.vehicle_id)}` : `Driver: ${returnNameDriver(image.driver_id)}`}</h3>
                                                                <h3>Document Name: {image.name}</h3>
                                                                <h3>Expiration Date: {new Date(image.expiryDate).toDateString()}</h3>
                                                                <br />
                                                            </div>
                                                        })    
                                            case "DXP1":
                                                return({
                                                    "DXP1": <div className="whiteBox">
                                                                <h3>{image.vehicle_id !== null ? `Van Registration: ${returnNameVehicle(image.vehicle_id)}` : `Driver: ${returnNameDriver(image.driver_id)}`}</h3>
                                                                <h3>Document Name: {image.name}</h3>
                                                                <h3>Expiration Date: {new Date(image.expiryDate).toDateString()}</h3>
                                                                <br />
                                                            </div>
                                                        })
                                            default:
                                                return
                                        }
                                    }
                                }
                            }
                        })
                    }
                }
            }))
            return result
        }
        awaitDataFunction().then( response => {
            let dvlaDbs2 = [<h3>DBS2</h3>]
            let dvlaDex2 = [<h3>DEX2</h3>]
            let dvlaDsn1 = [<h3>DSN1</h3>]
            let dvlaDCF1 = [<h3>DCF1</h3>]
            let dvlaDxp1 = [<h3>DXP1</h3>]

            response.forEach( dvlaEle => {
                // dbs2
                if (dvlaEle !== undefined) {
                    if (dvlaEle.DBS2) {
                        dvlaDbs2.push(
                            <>
                                {dvlaEle.DBS2}
                            </>
                        )
                    }
    
                    // dex2
                    if (dvlaEle.DEX2) {
                        dvlaDex2.push(
                            <>
                                {dvlaEle.DEX2}
                            </>
                        )
                    }
    
                    // dsn1
                    if (dvlaEle.DSN1) {
                        dvlaDsn1.push(
                            <>
                                {dvlaEle.DSN1}
                            </>
                        )
                    }
    
                    // DCF1
                    if (dvlaEle.DCF1) {
                        dvlaDCF1.push(
                            <>
                                {dvlaEle.DCF1}
                            </>
                        )
                    }
    
                    // dxp1
                    if (dvlaEle.DXP1) {
                        dvlaDxp1.push(
                            <>
                                {dvlaEle.DXP1}
                            </>
                        )
                    }
                }
            })
            if (dvlaDbs2.length > 1) {
                rightArray.push(dvlaDbs2)
            }
            if (dvlaDex2.length > 1) {
                rightArray.push(dvlaDex2)
            }
            if (dvlaDsn1.length > 1) {
                rightArray.push(dvlaDsn1)
            }
            if (dvlaDCF1.length > 1) {
                rightArray.push(dvlaDCF1)
            }
            if (dvlaDxp1.length > 1) {
                rightArray.push(dvlaDxp1)
            }
            rightArray.push(<h3>Expired</h3>)
            dvlaExpired.forEach( image => {
                if (image.name === 'DVLA Check') {
                    if (returnNameDriver(image.driver_id) !== 'not found') {
                        postData(`https://backendpajamas.herokuapp.com/driverimages/`, {
                            "driver_id": returnNameDriverImages(image.driver_id)
                        }).then ( response => {
                            let dvlaArray = []
                            response.data.forEach( image => {
                                if (image.name === 'DVLA Check') {
                                    dvlaArray.push(image)
                                }
                            })
                            dvlaArray.sort((a, b) => (new Date(a.expiryDate) > new Date(b.expiryDate)) ? 1 : -1)
                            let dvlaDoc = null
                            dvlaDoc = dvlaArray[dvlaArray.length - 1]
                            if (dvlaDoc.image_id === image.image_id) {
                                if (dvlaDoc !== null) {
                                    if (returnNameDriver(image.driver_id) !== 'not found') {
                                        rightArray.push(
                                            <div className='expiredDvlaContainer'>
                                                <h3>{image.vehicle_id !== null ? `Van Registration: ${returnNameVehicle(image.vehicle_id)}` : `Driver: ${returnNameDriver(image.driver_id)}`}</h3>
                                                <h3>Document Name: {image.name}</h3>
                                                <h3>Expiration Date: {new Date(image.expiryDate).toDateString()}</h3>
                                                <br />
                                            </div>
                                        )
                                    }
                                }
                            }
                        })
                    }
                }
            })
            expirationDatesArrayDivs.push(
                <h3>Expired</h3>
            )
            expiredArray.sort((a, b) => (new Date(a.expiryDate) > new Date(b.expiryDate) ? -1 : 1))
            expiredArray.forEach( image => {
                if (image.name !== 'D&A test' && image.name !== 'DVLA Check') {
                    if (image.vehicle_id !== null) {
                        if (returnNameVehicle(image.vehicle_id) !== 'not found') {
                            expirationDatesArrayDivs.push(
                                <div className='redOverlay'>
                                    <h3>{image.vehicle_id !== null ? `Van Registration: ${returnNameVehicle(image.vehicle_id)}` : `Driver: ${returnNameDriver(image.driver_id)}`}</h3>
                                    <h3>Document Name: {image.name}</h3>
                                    <h3>Expiration Date: {new Date(image.expiryDate).toDateString()}</h3>
                                    <br />
                                </div>
                            )
                        }
                    } else {
                        if (returnNameDriver(image.driver_id) !== 'not found') {
                            expirationDatesArrayDivs.push(
                                <div className='redOverlay'>
                                    <h3>{image.vehicle_id !== null ? `Van Registration: ${returnNameVehicle(image.vehicle_id)}` : `Driver: ${returnNameDriver(image.driver_id)}`}</h3>
                                    <h3>Document Name: {image.name}</h3>
                                    <h3>Expiration Date: {new Date(image.expiryDate).toDateString()}</h3>
                                    <br />
                                </div>
                            )
                        }
                    }
                }
            })
            setQuoteOfDay(rightArray)
        })
    }, [data])
    // useEffect( () => {
    //     let localArray = []
    //     if (quoteOfDay) {
    //         localArray.push(
    //             <div>
    //                 <h3>{quoteOfDay.quote}</h3>
    //                 <br />
    //                 <h4>- {quoteOfDay.author}</h4>
    //             </div>
    //         )
    //     }
    //     setQuoteOfDayArray(localArray)
    // }, [quoteOfDay])

    var content
    if (loadingGate === 2) {
        content = (
            <>
                <div className='home_content'>
                <NavigationBar title='Home' superUser={props.superUser ? true : false} email={props.user_email}/>
                    <div className='main_content_home_two'>
                        <div className='calandar_container'>
                            <div>
                                <div className='home_details'>
                                    <h2>Welcome {props.user_name}</h2>
                                    {todaysDrivers}
                                    <div id="demoHome">
                                        <div className="wrapper">
                                            <div className="content">
                                                <ul>
                                                    <a href="#0" onClick={(e, city) => handleSelectCity(e, 'DBS2')}><li>DBS2</li></a>
                                                    <a href="#0" onClick={(e, city) => handleSelectCity(e, 'DSN1')}><li>DSN1</li></a>
                                                    <a href="#0" onClick={(e, city) => handleSelectCity(e, 'DEX2')}><li>DEX2</li></a>
                                                    <a href="#0" onClick={(e, city) => handleSelectCity(e, 'DXP1')}><li>DXP1</li></a>
                                                    <a href="#0" onClick={(e, city) => handleSelectCity(e, 'DCF1')}><li>DCF1</li></a>
                                                </ul>
                                            </div>
                                            <div className="parent" >{selectedCity}</div>
                                        </div>
                                    </div>
                                </div>
                                <h3 className='home_time'>
                                    {dayArray[currentDate.getDay()]}, {currentDate.getDate()} {monthArray[currentDate.getMonth()]}, {currentDate.getFullYear()}
                                    <br />
                                    {currentDate.toLocaleTimeString()}
                                    <br />
                                    Week: {currentDate.getWeek()}
                                </h3>
                            </div>
                            <div>
                            </div>
                        </div>
                        <div className='lower_home_page'>
                            <div className='inner_lower_home_container'>
                                <h2>Documents</h2>
                                <div className='docs_for_verification_home_expiration'>
                                    {verifiedDocumentsDivs}
                                </div>
                            </div>
                            <div className='inner_lower_home_container'>
                                <h2>Expiring Documents</h2>
                                <div className='docs_for_verification_home_expiration'>
                                    {expirationList}
                                </div>
                            </div>
                            <div className='inner_lower_home_container' id="dvlaBottom">
                                <h2>Upcoming DVLA</h2>
                                <div className='docs_for_verification_home_expiration'>
                                    {quoteOfDay}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
            </>
        )
    } else if (loadingGate === 0) {
        content = (
            <div className='fade_class'>
                <div className="header">
                    <div className="inner-header flex">
                        <div className='containerForLoader'>
                            <div class="spinner">
                                <div class="bounce1"></div>
                                <div class="bounce2"></div>
                                <div class="bounce3"></div>
                                <div class="bounce4"></div>
                                <div class="bounce5"></div>
                            </div>
                        </div>
                        <h1 className='welcomeText'>{loadingMessage}</h1>
                        {/* <h3>This trial version uses a free heroku backend, which takes 30 seconds to load :)</h3> */}
                    </div>
                </div >
            </div>
        )
    } else {
        content = (
            <div className='fade_class'>
                <div className="header">
                    <div className="inner-header flex">
                        <div className='containerForLoader'>
                            <div class="spinner">
                                <div class="bounce1"></div>
                                <div class="bounce2"></div>
                                <div class="bounce3"></div>
                                <div class="bounce4"></div>
                                <div class="bounce5"></div>
                            </div>
                        </div>
                        <h1 className='welcomeText'>{loadingMessage}</h1>
                        {/* <h3>This trial version uses a free heroku backend, which takes 30 seconds to load :)</h3> */}
                    </div>
                </div >
            </div>
        )
    }

    return (
        <>
            {handleSchedule}
            {content}
        </>    
    )
}

export default Home